import { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import FPago from "./FPago";
import { useSelector } from "react-redux";
import { formatDinero } from "./../../../utils/formatDinero";
import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import ButtonClienteDetalle from "../../../global/ButtonClienteDetalle";
const columns = [
  { id: "cliente", minWidth: 150, align: "center", label: "Cliente" },
  { id: "referencia", minWidth: 150, align: "center", label: "Referencia" },
  { id: "adeudo", minWidth: 150, align: "center", label: "Avance" },
  { id: "montoMensual", minWidth: 150, align: "center", label: "Monto mensual" },
  { id: "total", minWidth: 150, align: "center", label: "Total a pagar" },
  { id: "action", minWidth: 50, align: "center", label: "Cargar pago" },
]
const useStyles = makeStyles({
  root: {
    width: "100%",
    marginTop: "15px",
  },
  container: {
    maxHeight: 440,
  },
})
export default function TPagos() {
  const rows = useSelector(store => store.pagoUnico.array);
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const history = useHistory()
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  }
  const handleClick = ({referencia}) => {
    history.push(`/ClienteReferencia/${referencia}`, {
      reservas: true
  })
  }
  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.Movimiento?.Cuenta?.Id_Cuenta}>
                    <TableCell align="center">
                      <Button onClick={() =>  handleClick({referencia: row.Movimiento?.Referencia})}>
                        {`${row.Movimiento?.Cuenta?.Nombre} ${row.Movimiento?.Cuenta?.Apellido_Paterno} ${row.Movimiento?.Cuenta?.Apellido_Materno}`}
                      </Button>
                    </TableCell>
                    <TableCell align="center">
                      <ButtonClienteDetalle referencia={row.Movimiento?.Referencia} />
                    </TableCell>
                    <TableCell align="center">{`${Math.trunc((row.Avance > 100) ? 100 : row.Avance )}%`}</TableCell>
                    <TableCell align="center">
                      {`${formatDinero(row.paquete?.Monto_Mensual)} ${row.Moneda?.Clave}`}
                    </TableCell>
                    <TableCell align="center">
                      {`${formatDinero(row.paquete?.Monto_Paquete)} ${row.Moneda?.Clave}`}
                    </TableCell>
                    <TableCell>
                      <FPago row={row}/>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
